// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__B4ZVE","description":"NotFoundBlock_description__IRj2h"};